export { default } from "./HowToPlay";
